<app-content-container>
  <div
    class="max-w-4xl p-10 mx-auto text-center border rounded-2xl bg-base-100 border-base-content/10 hover:border-primary/30 shadow-lg"
  >
    <h2 class="section-title">Mentorias da Code Dimension</h2>
    <p class="mt-6 section-description">
      Todo mês um tema escolhido pela comunidade, ao vivo com quem constrói
      software de verdade. Veja a agenda e participe.
    </p>
    <a
      class="mt-8 btn btn-primary"
      routerLink="/mentorias"
      data-testid="mentorship-banner-link"
    >
      Ver agenda das mentorias
    </a>
  </div>
</app-content-container>
